// extracted by mini-css-extract-plugin
module.exports = {"riskScoreCard":"index-module--riskScoreCard--2i4zd"};